import {ImageConfig} from "../../../../constants";
import React from "react";
import {CommonService} from "../../../../shared/services";
import "./ServiceCategoryModal.scss";
import {Row, Col} from "antd";
import SkeletonCard from "../../../../shared/components/skeleton-card/SkeletonCard";

interface ServiceCategoryModalProps {
    setIsServiceCategoryModalOpen?: any;
    serviceCategoryDetails?: any;
    facilityDetails?: any;
    isServiceCategoryDetailsLoading?: any
}


const ServiceCategoryModalComponent = ((props: ServiceCategoryModalProps) => {
    const {
        setIsServiceCategoryModalOpen,
        serviceCategoryDetails,
        facilityDetails,
        isServiceCategoryDetailsLoading
    } = props;
    return (
        <div className="service-category-modal">
            {isServiceCategoryDetailsLoading && <SkeletonCard/>}
            {!isServiceCategoryDetailsLoading && <div className={'service-category-modal-content'}>
                <div className="modal-title d-flex justify-content-space-between">
                    <div>
                        {facilityDetails?.name} -
                        ({CommonService.formatAddressBillAppointment(facilityDetails?.address)})
                    </div>
                    <div className={'cursor-pointer'} onClick={() => {
                        setIsServiceCategoryModalOpen(false)
                    }}>
                        <ImageConfig.CloseIcon color={"#1479FF"}/>
                    </div>
                </div>
                <div className="modal-subtitle mrg-bottom-15 mrg-top-15">Available services offered at this location:
                </div>
                <div className="category-container">
                    <Row gutter={[16, 16]}>
                        {serviceCategoryDetails && serviceCategoryDetails?.map((category: any) => (
                            <Col xs={24} sm={12} md={8} lg={6} key={category._id}>
                                <div className={'service-holder'}>
                                    <div className={'service-image-holder'}>
                                        <img
                                            alt={category?.name}
                                            src={category?.image?.url}
                                            loading={'eager'}
                                        />
                                    </div>
                                    <div
                                        className={'service-category-name-holder d-flex justify-content-space-between align-items-center'}>
                                        <div className={'category-name-text'}> {category.name}</div>
                                        {/*<div className={'mrg-left-30'}><ImageConfig.ServiceCardNavigatorIcon color={#}/></div>*/}
                                    </div>
                                </div>
                                <div className="services">
                                    {category.services.map((service: any) => (
                                        <div key={service._id} className="service-button">
                                            {service.name}
                                        </div>
                                    ))}
                                </div>
                            </Col>
                        ))}
                    </Row>
                </div>
            </div>}
        </div>
    )
})

export default ServiceCategoryModalComponent


